const { BlobServiceClient } = require('@azure/storage-blob')
import { v4 as uuidv4 } from 'uuid'

const account = process.env.VUE_APP_BLOB_ACCOUNT

const CONTAINER_DOCUMENT = 'dokument'
const CONTAINER_IMAGES = 'bilder'
const CONTAINER_PROFILE_IMAGES = 'profilbilder'


export default {
  createUpload: (container, file, name) => {
    let containerName
    let sasToken
    switch (container) {
      case CONTAINER_DOCUMENT:
        containerName = CONTAINER_DOCUMENT
        sasToken = process.env.VUE_APP_DOCUMENT_SAS_TOKEN
        break
      case CONTAINER_IMAGES:
        containerName = process.env.VUE_APP_IMAGE_CONTAINER
        sasToken = process.env.VUE_APP_IMAGE_SAS_TOKEN
        break
      case CONTAINER_PROFILE_IMAGES:
          containerName = process.env.VUE_APP_PROFILE_IMAGE_CONTAINER
          sasToken = process.env.VUE_APP_PROFILE_IMAGE_SAS_TOKEN
          break
      default:
        throw new Error('Not a valid container')
    }

    const blobServiceClient = new BlobServiceClient(
      `https://${account}.blob.core.windows.net?${sasToken}`
    )
    const containerClient = blobServiceClient.getContainerClient(containerName)

    const blockBlobClient = containerClient.getBlockBlobClient(name || file.name)

    return {
      name: name || file.name,
      size: file.size,
      type: file.type,
      uuid: uuidv4(),
      status: 'waiting',
      progress: 0,
      send: async function () {
        const self = this
        const res = await blockBlobClient.uploadBrowserData(file, {
          blockSize: 0.5 * 1024 * 1024, // 512kb blocks
          concurrency: 20, // 20 concurrency
          onProgress(evt) {
            const progress = Math.floor((evt.loadedBytes / file.size) * 100)
            self.status = 'pending'
            self.progress = progress
          },
          blobHTTPHeaders: { blobContentType: file.type },
        })
        const {
          status,
          request: { url },
        } = res._response
        if (status !== 201) {
          this.status = 'error'
        }
        if (status === 201) {
          this.status = 'success'
        }
        return { status, url: url.split('?')[0] }
      },
    }
  },
}
